import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Out of Box - International Company Registration Services",
  description = "Professional company registration services worldwide. Fast, reliable, and expert assistance for your business formation needs in over 50+ countries.",
  keywords = "company registration, business formation, international incorporation, offshore company, business setup, corporate services",
  image = "/logo512.png",
  url = window.location.href,
  type = "website",
  author = "Out of Box",
  locale = "en_US",
  structuredData = null
}) => {
  const siteUrl = process.env.REACT_APP_SITE_URL || window.location.origin;
  const fullImageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;
  const canonicalUrl = url || `${siteUrl}${window.location.pathname}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Out of Box" />
      <meta property="og:locale" content={locale} />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:site" content="@outofbox" />
      <meta name="twitter:creator" content="@outofbox" />

      {/* Additional SEO Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />

      {/* Business-specific Meta Tags */}
      <meta name="geo.region" content="Global" />
      <meta name="geo.placename" content="Worldwide" />
      <meta name="ICBM" content="0, 0" />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;